// Toate cererile către API trec pe aici: atașează linkul personal (token) sau identitatea de dev.
const TOKEN_KEY = 'cc10_token';

export function getToken() { try { return localStorage.getItem(TOKEN_KEY) || ''; } catch { return ''; } }
export function setToken(t: string) { localStorage.setItem(TOKEN_KEY, t.trim()); }
export function clearToken() { localStorage.removeItem(TOKEN_KEY); }

export function authHeaders(): Record<string, string> {
  const h: Record<string, string> = {};
  const token = getToken();
  if (token) h['Authorization'] = `Bearer ${token}`;
  const dev = localStorage.getItem('cc10_dev_user');
  if (dev) h['X-Dev-User'] = dev; // acceptat de server DOAR cu AUTH_MODE=dev
  return h;
}

export async function apiJson<T = any>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(path, {
    ...init,
    cache: 'no-store',
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(init.headers as any) }
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body.error || `Server ${res.status}`);
    (err as any).status = res.status;
    if (res.status === 401) (err as any).unauthorized = true;
    throw err;
  }
  return body as T;
}

// Linkul de invitație: https://…/#invite=TOKEN  → salvăm token-ul și curățăm adresa
export function captureInviteFromUrl(): boolean {
  const m = location.hash.match(/invite=([A-Za-z0-9_-]{20,})/);
  if (!m) return false;
  setToken(m[1]);
  history.replaceState(null, '', location.pathname + location.search);
  return true;
}

export function inviteLink(token: string) {
  return `${location.origin}/#invite=${token}`;
}
